import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

export default function AnimationImage() {
  
  const animationContainer = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: animationContainer.current!,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require('../../assets/animation/heroSection.json')
    });
    return () => anim.destroy();
  }, []);

  return (   
        <div className='animation-container' ref={animationContainer} />
    )
}